import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgReport = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M15 24H22V26H15V24ZM15 20H25V22H15V20ZM15 16H25V18H15V16ZM27 12H22.8C22.4 10.8 21.3 10 20 10C18.7 10 17.6 10.8 17.2 12H13C12.9 12 12.7 12 12.6 12C12.2 12.1 11.9 12.3 11.6 12.5C11.4 12.8 11.3 13 11.2 13.2C11.1 13.5 11 13.7 11 14V28C11 28.3 11.1 28.5 11.2 28.8C11.3 29.1 11.4 29.3 11.6 29.4C11.9 29.7 12.2 29.9 12.6 29.9C12.7 29.9 12.9 29.9 13 29.9H27C28.1 29.9 29 29 29 27.9V14C29 12.9 28.1 12 27 12ZM20 11.8C20.4 11.8 20.8 12.1 20.8 12.6C20.8 13.1 20.4 13.2 20 13.2C19.6 13.2 19.2 12.9 19.2 12.5C19.2 12.1 19.6 11.8 20 11.8ZM27 28H13V14H27V28Z",
		fill: "#00a4ec"
	})
});
export default SvgReport;
